var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c("v-progress-linear", {
        staticClass: "progress-linear",
        class: { "progress-linear-disabled": !_vm.showLoading },
        attrs: { indeterminate: true }
      }),
      _vm._v(" "),
      _c("app-toaster"),
      _vm._v(" "),
      _c("app-header", {
        class: { a11y: _vm.$store.getters.mapSettings.accessibleModeActive }
      }),
      _vm._v(" "),
      _c(
        "v-content",
        {
          staticClass: "app-content",
          class: { a11y: _vm.$store.getters.mapSettings.accessibleModeActive }
        },
        [
          _c("app-confirm"),
          _vm._v(" "),
          _c("app-info"),
          _vm._v(" "),
          _c(
            "transition",
            {
              attrs: {
                "enter-active-class": "animated fadeIn",
                "leave-active-class": "animated fadeOut",
                mode: "out-in"
              }
            },
            [
              _c("router-view", {
                directives: [
                  {
                    name: "title",
                    rawName: "v-title",
                    value: _vm.title,
                    expression: "title"
                  }
                ]
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("app-sidebar", {
        class: { a11y: _vm.$store.getters.mapSettings.accessibleModeActive }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", { render: render, staticRenderFns: staticRenderFns })
  }
}